import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@reserve/store/types'
import { IEDate, uGetDateFormat } from '@appbase/util';
import { openReserveCalendarItem } from '@reserve/popup-handler';
import modalHelper from '@appbase/util/modal-helper';
import * as dateutil from '@appbase/util/date-helper';
import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';

@Component({
    computed: mapGetters({
        dailyEvents: types.CALENDAR_DAILY_EVENT_LIST,
        selectedResources: types.SELECTED_RESOURCE_LIST,
        currentDate: types.CALENDAR_DATE_CURRENT,
        rightPaneOpen: types.CALENDAR_RIGHTPANE_OPEN,
    }),

    methods: mapActions({
        loadDailyEvents: types.CALENDAR_DAILY_EVENT_LOAD
    })
})
export default class ResourceEventList  extends Vue {
    loadDailyEvents!: () => Promise<any>;

    dailyEvents!: reserve.CalendarItem[];
    selectedResources!: reserve.ResourceItemBase[];
    currentDate!: reserve.DateItem;
    eventsModel: reserve.CalendarItem[] = [];
    rightPaneOpen!: boolean;

    @Watch('dailyEvents')
    onEventsChanged(newVal: reserve.CalendarItem[]) { 
        if(newVal.length > 0) {
            for(var i= 0; i < newVal.length; i++) {
              let removeFlag = false;
              if(dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00',new Date(newVal[i]['end'])) == dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', this.currentDate.date) && newVal[i]['isAllDayEvent'] === true) {
                  removeFlag = true
              } 

              if (removeFlag) {
                  newVal.splice(i, 1);
                  i--;
              }
            }
        }

        this.eventsModel = newVal.filter(
            m => m.id !== 'null');
    }

    @Watch('selectedResources')
    onSelectedResourceChanged(newVal: ewsResource.EwsResourceItem[]) {
        this.loadEvents();
    }

    @Watch('rightPaneOpen')
    onPaneOpen(newVal: boolean) {
        if(newVal) {
            this.loadEvents();
        }
    }

    created() {
        this.loadEvents();
    }

    loadEvents() {
        if(this.rightPaneOpen) {
            this.loadDailyEvents();
        }        
    }

    getAmpm(eventTime: string) {
        var dateTime = IEDate(eventTime);
        return dateTime.getHours() > 12 ? this.$t('W_PM').toString() : this.$t('W_AM').toString();
    }

    getTimetext(event: reserve.CalendarItem) {
        if(event.isAllDayEvent) {
            return this.$t('W_Schedule_Allday').toString();
        } else {
            return `${this.getAmpm(event.start)} ${uGetDateFormat('H:i', IEDate(event.start))}`;
        }        
    }

    getDuration(event: reserve.CalendarItem) {
        if(event.isAllDayEvent) {
            return "";
        } else {
            var start = IEDate(event.start);
            var end = IEDate(event.end);
            var duration = end.getTime() - start.getTime();

            return `${(duration / (1000 * 60 * 60)).toFixed(1)} ${this.$t('W_Hour').toString()}`;
        }        
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true;
        return colorClass;
    }

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence' || event.appointmentType === 'Exception') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else {
            openReserveCalendarItem(event);
        }      
    }
}